import { CreditCard } from 'pages/Settings/pages/Add-subscription/types/Add-subscription.types';
import cms from './cms';

export async function getCardsByUserId(authId: string): Promise<CreditCard[]> {
  try {
    const response = await cms.get(`/users/cards/${authId}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to getCardsByUserId 🚨');
  }
}
